(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-pu-quote]');
  if(!root) return;
  var cfgEl=root.querySelector('[data-pu-config]');
  if(!cfgEl) return;
  var CFG;
  try{ CFG=JSON.parse(cfgEl.textContent); }catch(e){ return; }
  if(!root.querySelector('[data-pu-guests]')) return; // success state, nothing to wire

  var $=function(sel){return root.querySelector(sel)};
  var $$=function(sel){return Array.prototype.slice.call(root.querySelectorAll(sel))};

  var touched=false, durTouched=false;
  var guests=$('[data-pu-guests]'), dur=$('[data-pu-dur]'), zoneSel=$('[data-pu-zone]'), power=$('[data-pu-power]');

  CFG.zones.forEach(function(z,i){
    var o=document.createElement('option');
    o.value=z.label; o.textContent=z.label;
    zoneSel.appendChild(o);
  });

  function money(n){ return '$'+Number(n).toLocaleString('en-US'); }
  function tierFor(g){
    for(var i=0;i<CFG.tiers.length;i++){ if(g<=CFG.tiers[i].max) return CFG.tiers[i]; }
    return CFG.tiers[CFG.tiers.length-1];
  }
  function addonState(){
    return CFG.addons.map(function(a){
      var row=root.querySelector('[data-pu-addon="'+a.id+'"]');
      if(!row) return null;
      var box=row.querySelector('[data-pu-box]');
      var qtyEl=row.querySelector('[data-pu-qty]');
      if(qtyEl) qtyEl.disabled=!box.checked;
      return {def:a,on:box.checked,qty:qtyEl?(parseInt(qtyEl.value,10)||1):1};
    }).filter(Boolean);
  }

  function go(n){
    $$('[data-pu-step]').forEach(function(el){ el.hidden = (+el.getAttribute('data-pu-step')!==n); });
    $('[data-pu-bar]').style.width=(n*20)+'%';
    $$('[data-pu-steps] b').forEach(function(b){
      var s=+b.getAttribute('data-s');
      b.classList.toggle('on',s===n); b.classList.toggle('done',s<n);
    });
    root.scrollIntoView({behavior:'smooth',block:'start'});
  }

  function powerLabel(){
    var v=power.value;
    if(v==='No') return 'NO \u2014 cannot serve without power';
    if(v==='Not sure') return 'Unconfirmed \u2014 needs checking with the venue';
    return 'Yes';
  }
  function powerCheck(){
    var v=power.value, w=$('[data-pu-powerwarn]');
    if(v==='Yes'){ w.hidden=true; return; }
    w.hidden=false;
    if(v==='No'){
      $('[data-pu-pw-title]').textContent='We can\u2019t run the cart without power';
      $('[data-pu-pw-body]').textContent='We don\u2019t carry a generator, so we need an outlet on site. It\u2019s worth asking your venue before you rule it out \u2014 there\u2019s often one closer than people expect. If they can make something work, send us your request anyway and we\u2019ll figure it out together.';
    }else{
      $('[data-pu-pw-title]').textContent='Worth confirming before the day';
      $('[data-pu-pw-body]').textContent='We\u2019ll need a standard outlet on its own 20-amp circuit, and we don\u2019t carry a generator. Send us your request and we\u2019ll help you figure out what to ask your venue for.';
    }
  }

  function recalc(){
    var g=parseInt(guests.value,10), t=tierFor(g);
    if(!durTouched){
      var want=String(t.hours);
      if(dur.querySelector('option[value="'+want+'"]')) dur.value=want;
    }
    var d=parseFloat(dur.value);
    var states=addonState();

    $('[data-pu-gcount]').textContent=g;
    $('[data-pu-guests-field]').value=String(g);
    var daysMore=root.querySelector('[data-pu-days="more"]').checked;
    $('[data-pu-days-note]').hidden=!daysMore;

    var lift=states.reduce(function(a,x){ return a+(x.on?x.def.lift:0) },0);
    var rate=CFG.baseRate+lift;

    var extra=Math.max(0,d-t.hours);
    var extraCost=Math.round(extra*CFG.extraHourPrice);
    $('[data-pu-durnote]').innerHTML = extra>0
      ? t.name+' includes '+t.hours+' hours. <b>'+(extra===1?'1 extra hour':extra+' extra hours')+' \u2014 '+money(extraCost)+'</b>'
      : (d < t.hours
          ? t.name+' includes up to '+t.hours+' hours \u2014 shorter is fine, the price is the same.'
          : t.name+' includes '+t.hours+' hours at this guest count.');

    var drinks=Math.round(g*CFG.drinksPerGuest), capacity=Math.round(rate*d), tight=drinks>capacity;
    var cap=$('[data-pu-cap]');
    cap.hidden=!tight; cap.classList.add('pu-cap--warn');
    if(tight){
      cap.querySelector('.l1').textContent='About '+drinks+' drinks in '+d+' hours';
      cap.querySelector('.l2').textContent='That\u2019s more than we can make. Try a longer window.';
    }

    var lines=[{l:t.name+' \u00b7 '+g+' guests',v:t.price}];
    if(extra>0) lines.push({l:'Extra time \u00b7 '+extra+'h',v:extraCost});
    var bring=[];
    states.forEach(function(x){
      if(!x.on) return;
      if(x.def.free){ bring.push(x.def.label); return; }
      var amount=x.def.price*(x.def.qty?x.qty:1);
      lines.push({l:x.def.label+(x.def.qty&&x.qty>1?' \u00d7 '+x.qty:''),v:amount});
    });

    var zi=zoneSel.selectedIndex; if(zi<0) zi=0;
    var zone=CFG.zones[zi], ask=(zone.price===-1);
    if(zone.price>0) lines.push({l:'Travel',v:zone.price});

    var total=lines.reduce(function(a,x){return a+x.v},0);
    var deposit=Math.round(total*(CFG.depositPct/100));

    if(touched){
      $('[data-pu-total]').textContent=money(total)+(ask?'+':'');
      $('[data-pu-tbk]').textContent=t.name;
      $('[data-pu-tbv]').textContent=g+' guests \u00b7 '+d+' hours'+(ask?' \u00b7 travel to confirm':'');
      $('[data-pu-tbdep]').textContent=money(deposit)+' deposit holds the date \u00b7 '+CFG.depositPct+'%, non-refundable';
    }else{
      $('[data-pu-total]').textContent='$0';
      $('[data-pu-tbk]').textContent='Your estimate';
      $('[data-pu-tbv]').textContent='Pick your guest count and how long';
      $('[data-pu-tbdep]').textContent='';
    }

    var extras=lines.slice(1).filter(function(x){return x.l!=='Travel'}).map(function(x){return x.l});
    var out={
      package:t.name,
      crew:'Both of us',
      addons:extras.length?extras.join(', '):'None',
      bring:bring.length?bring.join(', '):'Nothing extra',
      drinks:g+' guests -> about '+drinks+' drinks ('+CFG.drinksPerGuest+' per guest)',
      deposit:money(deposit)+' ('+CFG.depositPct+'%, non-refundable)',
      total:money(total)+(ask?' plus travel':'')
    };
    if(!touched){
      out.package='Not chosen yet'; out.total='Not chosen yet';
      out.deposit='Not chosen yet'; out.addons='None'; out.drinks='';
    }
    Object.keys(out).forEach(function(k){
      var el=root.querySelector('[data-pu-out="'+k+'"]');
      if(el) el.value=out[k];
    });
  }

  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-pu-go]');
    if(!b) return;
    e.preventDefault();
    var target=parseInt(b.getAttribute('data-pu-go'),10);
    var current=root.querySelector('[data-pu-step]:not([hidden])');
    if(current && target>+current.getAttribute('data-pu-step')){
      var fields=Array.prototype.slice.call(current.querySelectorAll('input,select,textarea'));
      for(var i=0;i<fields.length;i++){
        if(!fields[i].checkValidity()){ fields[i].reportValidity(); return; }
      }
    }
    go(target);
  });
  $$('[data-pu-qty]').forEach(function(q){ q.addEventListener('click',function(e){ e.stopPropagation(); }); });
  power.addEventListener('change',function(){ powerCheck(); });
  ['input','change'].forEach(function(ev){
    root.addEventListener(ev,function(e){
      if(e.target===dur) durTouched=true;
      if(e.target===guests || e.target===dur || e.target===zoneSel ||
         (e.target.closest && e.target.closest('[data-pu-addon]'))) touched=true;
      recalc();
    });
  });

  var formEl=root.querySelector('form');
  var sendBtn=root.querySelector('.pu-send');
  function syncSend(){
    if(!formEl||!sendBtn) return;
    var ok=formEl.checkValidity();
    sendBtn.disabled=!ok;
    var hint=root.querySelector('[data-pu-sendhint]');
    if(hint) hint.textContent = ok ? '' : 'Add your name and email on the last step to send';
  }
  ['input','change'].forEach(function(ev){ root.addEventListener(ev,syncSend); });

  /* Mirror each submission to the Perk Up quote-requests Google Sheet.
     Fire-and-forget: wrapped in try/catch and sent with sendBeacon, so it can
     never delay, block or break the native contact-form email. */
  var SHEET_URL='https://docs.google.com/forms/d/e/1FAIpQLSfCsFZzRTF_q_z7F2EbBVW3kAs7C8TEJxXmrqL8A0s2yBIdug/formResponse';
  var SHEET_DETAILS=['Occasion','Venue','Travel zone','Start time','Serving window',
    'Multiple days','Other days','Power on site','Parking and load-in','Baristas',
    'Drinks estimate','Deposit due','Menu additions','Menu notes','Also bring',
    'Larger event notes','Contact preference','How they heard'];

  if(formEl && window.FormData && navigator.sendBeacon){
    formEl.addEventListener('submit',function(){
      try{
        var fd=new FormData(formEl);
        var v=function(k){ var x=fd.get('contact['+k+']'); return x==null?'':String(x).trim(); };
        if(v('Website')) return; /* honeypot filled: a bot, keep it out of the sheet */

        var details=[];
        SHEET_DETAILS.forEach(function(k){ var x=v(k); if(x) details.push(k+': '+x); });
        var msg=v('body'); if(msg) details.push('Message: '+msg);

        var p=new URLSearchParams();
        p.append('entry.887034889',  v('name'));
        p.append('entry.1915325797', v('email'));
        p.append('entry.968725094',  v('Phone'));
        p.append('entry.1097772611', v('Event date'));
        p.append('entry.1047088001', v('Package'));
        p.append('entry.2059152473', v('Guest count'));
        p.append('entry.1352550316', v('Estimated total'));
        p.append('entry.688315128',  details.join('\n'));

        navigator.sendBeacon(SHEET_URL, new Blob([p.toString()],
          {type:'application/x-www-form-urlencoded;charset=UTF-8'}));
      }catch(e){ /* never interfere with the real submission */ }
    });
  }

  go(1); powerCheck(); recalc(); syncSend();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-rows"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-sr-more]').forEach(function (btn) {
      if (btn.dataset.srReady) return;
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;
      if (body.children.length < 2) { btn.remove(); return; }
      btn.dataset.srReady = '1';
      body.classList.add('is-clamped');
      btn.hidden = false;
      btn.textContent = btn.dataset.more;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var clamped = body.classList.toggle('is-clamped');
        btn.textContent = clamped ? btn.dataset.more : btn.dataset.less;
        btn.setAttribute('aria-expanded', String(!clamped));
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
